import { isObject, isString } from './type';

type Entry = string | Record<string, any> | undefined | null;

const reduceEntries = (acc: string[], value: Entry) => {
  if (isObject(value)) {
    for (const name in value) {
      if (value[name]) {
        acc.push(name);
      }
    }
  } else if (isString(value) && value) {
    acc.push(value);
  }
  return acc;
};

export const classNames = (...args: Entry[]) => args.reduce<string[]>(reduceEntries, []).join(' ');
